import { Flex, GridItem, Table, Tbody, Td, Text, Textarea, Th, Thead, Tr, useToast } from '@chakra-ui/react'
import { Button } from '../../../components/Button'
import { z } from 'zod'
import { zodResolver } from '@hookform/resolvers/zod'
import { useForm } from 'react-hook-form'
import { useMutation } from 'react-query'
import { onUpdateObservacoes } from './functions/updateObservacoes'

const schema = z.object({
  xped_ordem_compra: z.string().optional(),
  observacao_financeiro: z.string().optional(),
  observacao_nota: z.string().optional(),

  numero_nota: z.string().nonempty(),
  obs_ordemproducao: z.string().optional(),
})

export function AtualizarObservacoes({ numeroNota, dadosPedido }) {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: zodResolver(schema),
    defaultValues: {
      xped_ordem_compra: dadosPedido?.xped_ordem_compra,
      observacao_financeiro: dadosPedido?.observacao_financeiro,
      observacao_nota: dadosPedido?.observacao_nota,
      obs_ordemproducao: dadosPedido?.obs_ordemproducao,
      numero_nota: numeroNota,
    },
  })

  const toast = useToast({
    position: 'top-right',
    duration: 3000,
    isClosable: true,
  })

  const { mutateAsync, isLoading: loading } = useMutation({
    mutationFn: onUpdateObservacoes,
    onSuccess: () => {
      toast({
        title: 'Observações atualizadas com sucesso',
        status: 'success',
      })
    },
    onError: (error) => {
      toast({
        title: 'Erro ao atualizar observações',
        description: error.message,
        status: 'error',
      })
    },
  })

  async function onSubmit(data) {
    await mutateAsync(data)
  }

  return (
    <Flex flexDir="column" gap={4} as="form" onSubmit={handleSubmit(onSubmit)}>
      <input type="hidden" {...register('numero_nota')} value={numeroNota} />

      <Table size="sm">
        <Thead>
          <Th w="400px">Informação</Th>
          <Th>Observação</Th>
        </Thead>
        <Tbody>
          <Tr>
            <Td>
              <Text as="label" htmlFor="xped_ordem_compra">
                X Ped Ordem Compra
              </Text>
            </Td>
            <Td>
              <Textarea
                id="xped_ordem_compra"
                borderRadius="0"
                // disabled={!aprovado}
                bgColor={'#F5F5F5'}
                _hover={{ borderColor: '#F5F5F5' }}
                _focus={{ borderColor: '#F5F5F5' }}
                borderColor={'#F5F5F5'}
                placeholder="X Ped Ordem Compra"
                resize="none"
                rows={1}
                {...register('xped_ordem_compra')}
                isInvalid={!!errors.xped_ordem_compra}
                errorBorderColor="red.300"
              />
            </Td>
          </Tr>
          <Tr>
            <Td>
              <Text as="label" htmlFor="observacao_financeiro">
                Observação do Financeiro
              </Text>
            </Td>
            <Td>
              <Textarea
                id="observacao_financeiro"
                borderRadius="0"
                // disabled={!aprovado}
                bgColor={'#F5F5F5'}
                _hover={{ borderColor: '#F5F5F5' }}
                _focus={{ borderColor: '#F5F5F5' }}
                borderColor={'#F5F5F5'}
                placeholder="Observação do financeiro"
                resize="none"
                rows={1}
                {...register('observacao_financeiro')}
                isInvalid={!!errors.observacao_financeiro}
                errorBorderColor="red.300"
              />
            </Td>
          </Tr>
          <Tr>
            <Td>
              <Text as="label" htmlFor="observacao_nota">
                Observação da NF / Ordem de Compra
              </Text>
            </Td>
            <Td>
              <Textarea
                id="observacao_nota"
                borderRadius="0"
                // disabled={!aprovado}
                bgColor={'#F5F5F5'}
                _hover={{ borderColor: '#F5F5F5' }}
                _focus={{ borderColor: '#F5F5F5' }}
                borderColor={'#F5F5F5'}
                placeholder="Observação da NF / Ordem de Compra"
                resize="none"
                rows={1}
                {...register('observacao_nota')}
                isInvalid={!!errors.observacao_nota}
                errorBorderColor="red.300"
              />
            </Td>
          </Tr>
          <Tr>
            <Td>
              <Text as="label" htmlFor="obs_ordemproducao">
                Observação de Produção
              </Text>
            </Td>
            <Td>
              <Textarea
                id="obs_ordemproducao"
                borderRadius="0"
                // disabled={!aprovado}
                bgColor={'#F5F5F5'}
                _hover={{ borderColor: '#F5F5F5' }}
                _focus={{ borderColor: '#F5F5F5' }}
                borderColor={'#F5F5F5'}
                placeholder="Observação de Produção"
                resize="none"
                rows={1}
                {...register('obs_ordemproducao')}
                isInvalid={!!errors.obs_ordemproducao}
                errorBorderColor="red.300"
              />
            </Td>
          </Tr>
        </Tbody>
      </Table>

      <GridItem colSpan={6}>
        <Button ml="auto" loadingText="Enviando..." type="submit" isLoading={loading}>
          Atualizar Observações
        </Button>
      </GridItem>
    </Flex>
  )
}
